// src/components/StudentProfileView.jsx
import React, { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";
import axios from "axios";
import "../assets/css/student-profile.css";
import "../assets/css/editprofile2.css";

const isProduction = process.env.NODE_ENV === "production";
const API_BASE_URL = isProduction
  ? "https://schools.luth.gov.ng" || "https://10.0.0.57"
  : "http://localhost:3003";

export default function StudentProfileView() {
  // const API = process.env.REACT_APP_API_BASE_URL || "http://localhost:3003";
  const storedMatric = localStorage.getItem("matricNo");
  const token = localStorage.getItem("token");
  const storedProgramme = localStorage.getItem("programme") || "";
  const storedFullName = localStorage.getItem("fullName") || "";

  const toDateInputValue = (dateValue) => {
    if (!dateValue) return "";
    const d = new Date(dateValue);
    if (Number.isNaN(d.getTime())) return "";
    return d.toISOString().split("T")[0];
  };

  const formatDate = (iso) => {
    if (!iso) return "N/A";
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return "N/A";
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [isNewStudent, setIsNewStudent] = useState(false);
  const [saving, setSaving] = useState(false);

  const [formData, setFormData] = useState({
    fullName: "",
    matricNumber: storedMatric || "",
    picture: "",
    dateOfBirth: "",
    gender: "",
    maritalStatus: "",
    email: "",
    phoneNumber: "",
    address: "",
    department: storedProgramme,
    sponsorName: "",
    sponsorPhone1: "",
    sponsorPhone2: "",
    sponsorEmail: "",
    sponsorAddress: "",
    nextOfKinName: "",
    nextOfKinPhone: "",
    nextOfKinAddress: "",
    nextOfKinRelationship: "",
    nextOfKinEmail: "",
    nationality: "",
    stateOfOrigin: "",
    lga: "",
    religion: "",
    jambRegNo: "",
    primarySchool: "",
    primaryGradYear: "",
    primaryQualification: "",
    secondarySchool: "",
    secondaryGradYear: "",
    secondaryQualification: "",
    postSecondarySchool: "",
    postSecondaryGradYear: "",
    postSecondaryQualification: "",
    otherQualification: "",
    otherQualificationYear: "",
    otherQualificationSchool: "",
    entryMode: "jamb",
    entryYear: "",
    level: "ND1",
  });

  useEffect(() => {
    if (!storedMatric) {
      setError("No matriculation number found. Please log in.");
      setLoading(false);
      return;
    }

    async function fetchProfile() {
      try {
        const res = await axios.get(
          `${API_BASE_URL}/api/students-view/${encodeURIComponent(storedMatric)}`,
          {
            headers: token ? { Authorization: `Bearer ${token}` } : {},
          }
        );

        const data = res.data || {};
        setProfile(data);
        setIsNewStudent(false);

        setFormData((prev) => ({
          ...prev,
          fullName: data.fullName || storedFullName || "",
          matricNumber: data.matricNumber || storedMatric,
          picture: data.picture || "",
          dateOfBirth: toDateInputValue(data.dateOfBirth || data.dob),
          gender: data.gender || "",
          maritalStatus: data.maritalStatus || "",
          email: data.email || "",
          phoneNumber: data.phoneNumber || data.phone || "",
          address: data.address || "",
          department: data.department || storedProgramme,
          sponsorName: data.sponsorName || "",
          sponsorPhone1: data.sponsorPhone1 || "",
          sponsorPhone2: data.sponsorPhone2 || "",
          sponsorEmail: data.sponsorEmail || "",
          sponsorAddress: data.sponsorAddress || "",
          nextOfKinName: data.nextOfKinName || data.nextOfKin || "",
          nextOfKinPhone: data.nextOfKinPhone || "",
          nextOfKinAddress: data.nextOfKinAddress || "",
          nextOfKinRelationship: data.nextOfKinRelationship || "",
          nextOfKinEmail: data.nextOfKinEmail || "",
          nationality: data.nationality || "",
          stateOfOrigin: data.stateOfOrigin || "",
          lga: data.lga || "",
          religion: data.religion || "",
          jambRegNo: data.jambRegNumber || data.jambRegNo || "",
          primarySchool: data.primarySchool || "",
          primaryGradYear: data.primaryGradYear || "",
          primaryQualification: data.primaryQualification || "",
          secondarySchool: data.secondarySchool || "",
          secondaryGradYear: data.secondaryGradYear || "",
          secondaryQualification: data.secondaryQualification || "",
          postSecondarySchool: data.postSecondarySchool || "",
          postSecondaryGradYear: data.postSecondaryGradYear || "",
          postSecondaryQualification: data.postSecondaryQualification || "",
          otherQualification: data.otherQualification || "",
          otherQualificationYear: data.otherQualificationYear || "",
          otherQualificationSchool: data.otherQualificationSchool || "",
          entryMode: data.entryMode || "jamb",
          entryYear: data.entryYear ? String(data.entryYear) : "",
          level: data.level || data.Level || "ND1",
        }));
      } catch (err) {
        if (err.response && err.response.status === 404) {
          setIsNewStudent(true);
          setProfile(null);
          setFormData((prev) => ({
            ...prev,
            fullName: storedFullName,
            matricNumber: storedMatric || "",
            department: storedProgramme,
            dateOfBirth: "",
            entryMode: "jamb",
            level: "ND1",
          }));
        } else {
          console.error("Error fetching profile:", err);
          setError("Failed to load profile.");
        }
      } finally {
        setLoading(false);
      }
    }

    fetchProfile();
  }, [API_BASE_URL, storedMatric, token, storedProgramme, storedFullName]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setError("");

    if (!formData.dateOfBirth) {
      setError("Date of birth is required.");
      setSaving(false);
      return;
    }

    if (!formData.jambRegNo) {
      setError("JAMB registration number is required.");
      setSaving(false);
      return;
    }

    const payload = {
      fullName: formData.fullName,
      dob: toDateInputValue(formData.dateOfBirth),
      gender: formData.gender,
      maritalStatus: formData.maritalStatus,
      email: formData.email,
      phone: formData.phoneNumber,
      address: formData.address,
      matricNo: formData.matricNumber,
      department: formData.department || storedProgramme,
      sponsorName: formData.sponsorName,
      sponsorPhone: formData.sponsorPhone1,
      sponsorPhone2: formData.sponsorPhone2,
      sponsorEmail: formData.sponsorEmail,
      sponsorAddress: formData.sponsorAddress,
      nextOfKin: formData.nextOfKinName,
      nextOfKinPhone: formData.nextOfKinPhone,
      nextOfKinAddress: formData.nextOfKinAddress,
      nextOfKinRelationship: formData.nextOfKinRelationship,
      nextOfKinEmail: formData.nextOfKinEmail,
      nationality: formData.nationality,
      stateOfOrigin: formData.stateOfOrigin,
      lga: formData.lga,
      religion: formData.religion,
      jambRegNo: formData.jambRegNo,
      primarySchool: formData.primarySchool,
      primaryGradYear: formData.primaryGradYear
        ? Number(formData.primaryGradYear)
        : null,
      primaryQualification: formData.primaryQualification,
      secondarySchool: formData.secondarySchool,
      secondaryGradYear: formData.secondaryGradYear
        ? Number(formData.secondaryGradYear)
        : null,
      secondaryQualification: formData.secondaryQualification,
      postSecondarySchool: formData.postSecondarySchool,
      postSecondaryGradYear: formData.postSecondaryGradYear
        ? Number(formData.postSecondaryGradYear)
        : null,
      postSecondaryQualification: formData.postSecondaryQualification,
      otherQualification: formData.otherQualification,
      otherQualificationYear: formData.otherQualificationYear
        ? Number(formData.otherQualificationYear)
        : null,
      otherQualificationSchool: formData.otherQualificationSchool,
      entryMode: "jamb",
      entryYear: formData.entryYear ? Number(formData.entryYear) : null,
      level: "ND1",
    };

    try {
      await axios.post(`${API_BASE_URL}/api/biodata`, payload, {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      });

      const res = await axios.get(
        `${API_BASE_URL}/api/students-view/${encodeURIComponent(storedMatric)}`,
        {
          headers: token ? { Authorization: `Bearer ${token}` } : {},
        }
      );

      setProfile(res.data || {});
      setIsNewStudent(false);
    } catch (err) {
      console.error("Error saving biodata:", err);
      setError(
        err.response?.data?.msg || "Unable to save biodata. Please try again."
      );
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <div className="loading">Loading profile...</div>;
  if (error) return <div className="error">{error}</div>;

  return (
    <div className="student-profile-container" style={{ marginTop: "-130px" }}>
      <Sidebar />
      <div className="profile-main">
        {isNewStudent ? (
          <div className="profile-form-wrapper">
            <h1>Complete Your Biodata</h1>
            <p>Please fill in your biodata to complete your profile.</p>

            <form className="profile-form" onSubmit={handleSubmit}>
              <section className="form-section">
                <h2>Personal Information</h2>
                <div className="profile-grid">
                  <div className="form-group">
                    <label>Full Name</label>
                    <input
                      type="text"
                      name="fullName"
                      value={formData.fullName}
                      onChange={handleChange}
                      placeholder="Full Name"
                    />
                  </div>

                  <div className="form-group">
                    <label>Matric Number</label>
                    <input
                      type="text"
                      name="matricNumber"
                      value={formData.matricNumber}
                      readOnly
                    />
                  </div>

                  <div className="form-group">
                    <label>Date of Birth</label>
                    <input
                      type="date"
                      name="dateOfBirth"
                      value={formData.dateOfBirth}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label>Gender</label>
                    <input
                      type="text"
                      name="gender"
                      value={formData.gender}
                      onChange={handleChange}
                      placeholder="Gender"
                    />
                  </div>

                  <div className="form-group">
                    <label>Nationality</label>
                    <input
                      type="text"
                      name="nationality"
                      value={formData.nationality}
                      onChange={handleChange}
                      placeholder="Nationality"
                    />
                  </div>

                  <div className="form-group">
                    <label>State of Origin</label>
                    <input
                      type="text"
                      name="stateOfOrigin"
                      value={formData.stateOfOrigin}
                      onChange={handleChange}
                      placeholder="State of Origin"
                    />
                  </div>

                  <div className="form-group">
                    <label>LGA</label>
                    <input
                      type="text"
                      name="lga"
                      value={formData.lga}
                      onChange={handleChange}
                      placeholder="LGA"
                    />
                  </div>

                  <div className="form-group">
                    <label>Religion</label>
                    <input
                      type="text"
                      name="religion"
                      value={formData.religion}
                      onChange={handleChange}
                      placeholder="Religion"
                    />
                  </div>

                  <div className="form-group">
                    <label>Marital Status</label>
                    <input
                      type="text"
                      name="maritalStatus"
                      value={formData.maritalStatus}
                      onChange={handleChange}
                      placeholder="Marital Status"
                    />
                  </div>
                </div>
              </section>

              <section className="form-section">
                <h2>Contact Details</h2>
                <div className="profile-grid">
                  <div className="form-group">
                    <label>Phone Number</label>
                    <input
                      type="text"
                      name="phoneNumber"
                      value={formData.phoneNumber}
                      onChange={handleChange}
                      placeholder="Phone Number"
                    />
                  </div>

                  <div className="form-group">
                    <label>Email</label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="Email"
                    />
                  </div>

                  <div className="form-group full-width">
                    <label>Address</label>
                    <input
                      type="text"
                      name="address"
                      value={formData.address}
                      onChange={handleChange}
                      placeholder="Address"
                    />
                  </div>
                </div>
              </section>

              <section className="form-section">
                <h2>Next of Kin</h2>
                <div className="profile-grid">
                  <div className="form-group">
                    <label>Next of Kin Name</label>
                    <input
                      type="text"
                      name="nextOfKinName"
                      value={formData.nextOfKinName}
                      onChange={handleChange}
                      placeholder="Next of Kin Name"
                    />
                  </div>

                  <div className="form-group">
                    <label>Relationship</label>
                    <input
                      type="text"
                      name="nextOfKinRelationship"
                      value={formData.nextOfKinRelationship}
                      onChange={handleChange}
                      placeholder="Relationship"
                    />
                  </div>

                  <div className="form-group">
                    <label>Phone</label>
                    <input
                      type="text"
                      name="nextOfKinPhone"
                      value={formData.nextOfKinPhone}
                      onChange={handleChange}
                      placeholder="Phone"
                    />
                  </div>

                  <div className="form-group full-width">
                    <label>Address</label>
                    <input
                      type="text"
                      name="nextOfKinAddress"
                      value={formData.nextOfKinAddress}
                      onChange={handleChange}
                      placeholder="Address"
                    />
                  </div>

                  <div className="form-group">
                    <label>Email</label>
                    <input
                      type="email"
                      name="nextOfKinEmail"
                      value={formData.nextOfKinEmail}
                      onChange={handleChange}
                      placeholder="Email"
                    />
                  </div>
                </div>
              </section>

              <section className="form-section">
                <h2>Education History</h2>
                <div className="profile-grid">
                  <div className="form-group full-width">
                    <label>Primary School</label>
                    <input
                      type="text"
                      name="primarySchool"
                      value={formData.primarySchool}
                      onChange={handleChange}
                      placeholder="Primary School"
                    />
                  </div>

                  <div className="form-group">
                    <label>Primary Graduation Year</label>
                    <input
                      type="text"
                      name="primaryGradYear"
                      value={formData.primaryGradYear}
                      onChange={handleChange}
                      placeholder="Year"
                    />
                  </div>

                  <div className="form-group full-width">
                    <label>Primary Qualification</label>
                    <input
                      type="text"
                      name="primaryQualification"
                      value={formData.primaryQualification}
                      onChange={handleChange}
                      placeholder="Primary Qualification"
                    />
                  </div>

                  <div className="form-group full-width">
                    <label>Secondary School</label>
                    <input
                      type="text"
                      name="secondarySchool"
                      value={formData.secondarySchool}
                      onChange={handleChange}
                      placeholder="Secondary School"
                    />
                  </div>

                  <div className="form-group">
                    <label>Secondary Graduation Year</label>
                    <input
                      type="text"
                      name="secondaryGradYear"
                      value={formData.secondaryGradYear}
                      onChange={handleChange}
                      placeholder="Year"
                    />
                  </div>

                  <div className="form-group full-width">
                    <label>Secondary Qualification</label>
                    <input
                      type="text"
                      name="secondaryQualification"
                      value={formData.secondaryQualification}
                      onChange={handleChange}
                      placeholder="Secondary Qualification"
                    />
                  </div>

                  <div className="form-group full-width">
                    <label>Post-Secondary School</label>
                    <input
                      type="text"
                      name="postSecondarySchool"
                      value={formData.postSecondarySchool}
                      onChange={handleChange}
                      placeholder="Post-Secondary School"
                    />
                  </div>

                  <div className="form-group">
                    <label>Post-Secondary Graduation Year</label>
                    <input
                      type="text"
                      name="postSecondaryGradYear"
                      value={formData.postSecondaryGradYear}
                      onChange={handleChange}
                      placeholder="Year"
                    />
                  </div>

                  <div className="form-group full-width">
                    <label>Post-Secondary Qualification</label>
                    <input
                      type="text"
                      name="postSecondaryQualification"
                      value={formData.postSecondaryQualification}
                      onChange={handleChange}
                      placeholder="Post-Secondary Qualification"
                    />
                  </div>

                  <div className="form-group full-width">
                    <label>Other Qualification</label>
                    <input
                      type="text"
                      name="otherQualification"
                      value={formData.otherQualification}
                      onChange={handleChange}
                      placeholder="Other Qualification"
                    />
                  </div>

                  <div className="form-group">
                    <label>Other Qualification Year</label>
                    <input
                      type="text"
                      name="otherQualificationYear"
                      value={formData.otherQualificationYear}
                      onChange={handleChange}
                      placeholder="Year"
                    />
                  </div>

                  <div className="form-group full-width">
                    <label>Other Qualification School</label>
                    <input
                      type="text"
                      name="otherQualificationSchool"
                      value={formData.otherQualificationSchool}
                      onChange={handleChange}
                      placeholder="School"
                    />
                  </div>
                </div>
              </section>

              <section className="form-section">
                <h2>Sponsor Details</h2>
                <div className="profile-grid">
                  <div className="form-group">
                    <label>Sponsor Name</label>
                    <input
                      type="text"
                      name="sponsorName"
                      value={formData.sponsorName}
                      onChange={handleChange}
                      placeholder="Sponsor Name"
                    />
                  </div>

                  <div className="form-group">
                    <label>Sponsor Phone 1</label>
                    <input
                      type="text"
                      name="sponsorPhone1"
                      value={formData.sponsorPhone1}
                      onChange={handleChange}
                      placeholder="Sponsor Phone 1"
                    />
                  </div>

                  <div className="form-group">
                    <label>Sponsor Phone 2</label>
                    <input
                      type="text"
                      name="sponsorPhone2"
                      value={formData.sponsorPhone2}
                      onChange={handleChange}
                      placeholder="Sponsor Phone 2"
                    />
                  </div>

                  <div className="form-group">
                    <label>Sponsor Email</label>
                    <input
                      type="email"
                      name="sponsorEmail"
                      value={formData.sponsorEmail}
                      onChange={handleChange}
                      placeholder="Sponsor Email"
                    />
                  </div>

                  <div className="form-group full-width">
                    <label>Sponsor Address</label>
                    <input
                      type="text"
                      name="sponsorAddress"
                      value={formData.sponsorAddress}
                      onChange={handleChange}
                      placeholder="Sponsor Address"
                    />
                  </div>
                </div>
              </section>

              <section className="form-section">
                <h2>Academic Details</h2>
                <div className="profile-grid">
                  <div className="form-group">
                    <label>Programme</label>
                    <input
                      type="text"
                      name="department"
                      value={formData.department}
                      readOnly
                    />
                  </div>

                  <div className="form-group">
                    <label>Entry Level</label>
                    <input
                      type="text"
                      name="level"
                      value={formData.level}
                      readOnly
                    />
                  </div>

                  <div className="form-group">
                    <label>Entry Mode</label>
                    <input
                      type="text"
                      name="entryMode"
                      value={formData.entryMode}
                      readOnly
                    />
                  </div>

                  <div className="form-group">
                    <label>Entry Year</label>
                    <input
                      type="text"
                      name="entryYear"
                      value={formData.entryYear}
                      onChange={handleChange}
                      placeholder="Entry Year"
                    />
                  </div>

                  <div className="form-group">
                    <label>JAMB Registration No</label>
                    <input
                      type="text"
                      name="jambRegNo"
                      value={formData.jambRegNo}
                      onChange={handleChange}
                      placeholder="JAMB Registration No"
                      required
                    />
                  </div>
                </div>
              </section>

              <button type="submit" disabled={saving} className="save-btn">
                {saving ? "Saving..." : "Save Biodata"}
              </button>
            </form>
          </div>
        ) : (
          <>
            <div className="profile-header">
              <img
                src={profile.picture || "/default-avatar.png"}
                alt={`${profile.fullName} avatar`}
                className="profile-avatar"
              />
              <h1>{profile.fullName}</h1>
              <span className="profile-id">Matric No: {profile.matricNumber}</span>
            </div>

            <div className="profile-sections">
              <section>
                <h2>Personal Information</h2>
                <div className="profile-grid">
                  <div>
                    <strong>Date of Birth:</strong> {formatDate(profile.dateOfBirth || profile.dob)}
                  </div>
                  <div>
                    <strong>Gender:</strong> {profile.gender || "N/A"}
                  </div>
                  <div>
                    <strong>Nationality:</strong> {profile.nationality || "N/A"}
                  </div>
                  <div>
                    <strong>State of Origin:</strong> {profile.stateOfOrigin || "N/A"}
                  </div>
                  <div>
                    <strong>LGA:</strong> {profile.lga || "N/A"}
                  </div>
                  <div>
                    <strong>Religion:</strong> {profile.religion || "N/A"}
                  </div>
                  <div>
                    <strong>Marital Status:</strong> {profile.maritalStatus || "N/A"}
                  </div>
                </div>
              </section>

              <section>
                <h2>Contact Details</h2>
                <div className="profile-grid">
                  <div>
                    <strong>Phone:</strong> {profile.phoneNumber || profile.phone || "N/A"}
                  </div>
                  <div>
                    <strong>Email:</strong> {profile.email || "N/A"}
                  </div>
                  <div className="full-width">
                    <strong>Address:</strong> {profile.address || "N/A"}
                  </div>
                </div>
              </section>

              <section>
                <h2>Next of Kin</h2>
                <div className="profile-grid">
                  <div>
                    <strong>Name:</strong> {profile.nextOfKinName || profile.nextOfKin || "N/A"}
                  </div>
                  <div>
                    <strong>Relationship:</strong> {profile.nextOfKinRelationship || "N/A"}
                  </div>
                  <div>
                    <strong>Phone:</strong> {profile.nextOfKinPhone || "N/A"}
                  </div>
                  <div className="full-width">
                    <strong>Address:</strong> {profile.nextOfKinAddress || "N/A"}
                  </div>
                  <div>
                    <strong>Email:</strong> {profile.nextOfKinEmail || "N/A"}
                  </div>
                </div>
              </section>

              <section>
                <h2>Education History</h2>
                <div className="profile-grid">
                  <div className="full-width">
                    <strong>Primary School:</strong> {profile.primarySchool || "N/A"} (
                    {profile.primaryGradYear || "N/A"}) - {profile.primaryQualification || "N/A"}
                  </div>
                  <div className="full-width">
                    <strong>Secondary School:</strong> {profile.secondarySchool || "N/A"} (
                    {profile.secondaryGradYear || "N/A"}) - {profile.secondaryQualification || "N/A"}
                  </div>
                  <div className="full-width">
                    <strong>Post-Secondary:</strong> {profile.postSecondarySchool || "N/A"} (
                    {profile.postSecondaryGradYear || "N/A"}) - {profile.postSecondaryQualification || "N/A"}
                  </div>
                  <div className="full-width">
                    <strong>Other Qualification:</strong> {profile.otherQualification || "N/A"} (
                    {profile.otherQualificationYear || "N/A"}) - {profile.otherQualificationSchool || "N/A"}
                  </div>
                </div>
              </section>

              <section>
                <h2>Sponsor Details</h2>
                <div className="profile-grid">
                  <div>
                    <strong>Name:</strong> {profile.sponsorName || "N/A"}
                  </div>
                  <div>
                    <strong>Phone 1:</strong> {profile.sponsorPhone1 || "N/A"}
                  </div>
                  <div>
                    <strong>Phone 2:</strong> {profile.sponsorPhone2 || "N/A"}
                  </div>
                  <div>
                    <strong>Email:</strong> {profile.sponsorEmail || "N/A"}
                  </div>
                  <div className="full-width">
                    <strong>Address:</strong> {profile.sponsorAddress || "N/A"}
                  </div>
                </div>
              </section>

              <section>
                <h2>Academic Details</h2>
                <div className="profile-grid">
                  <div>
                    <strong>Department:</strong> {profile.department || "N/A"}
                  </div>
                  <div>
                    <strong>Level:</strong> {profile.level || profile.Level || "N/A"}
                  </div>
                  <div>
                    <strong>Entry Mode:</strong> {profile.entryMode || "N/A"}
                  </div>
                  <div>
                    <strong>Entry Year:</strong> {profile.entryYear || "N/A"}
                  </div>
                  <div>
                    <strong>JAMB Reg No:</strong> {profile.jambRegNumber || profile.jambRegNo || "N/A"}
                  </div>
                </div>
              </section>
            </div>
          </>
        )}
      </div>
    </div>
  );
}